
import React from "react";
import Layout from "@/components/Layout";
import Hero from "@/components/home/Hero";
import Features from "@/components/home/Features";
import Testimonials from "@/components/home/Testimonials";
import PromptExamples from "@/components/home/PromptExamples";
import CTA from "@/components/home/CTA";
import AgendaPreview from "@/components/home/AgendaPreview";

const Index = () => {
  return (
    <Layout>
      <Hero />
      <Features />
      <AgendaPreview />
      <PromptExamples />
      <Testimonials />
      <CTA />
    </Layout>
  );
};

export default Index;
